module.exports = ''
+ '<div class="creek-shows-container">'
+ '  <creek-shows-nav :shows-nav-text="showsNavText" :weekday-selected="weekdayNumber"></creek-shows-nav>'
+ '  <div v-if="showsByWeekday" class="creek-shows">'
+ '    <creek-show :data-show="show" v-for="show in showsForSelectedWeekday"></creek-show>'
+ '  </div>'
+ '  <div v-if="!showsByWeekday" class="creek-shows">'
+ '    '+Creek.data.router.loadingHtml
+ '  </div>'
+ '</div>'


// WEBPACK FOOTER //
// ./src/templates/page-shows.js